export default class EligibilityConstants {
    public static readonly ITEMS_PER_PAGE_COUNT = 100;
    public static readonly GCID_RELATED_BUNDLE_NAME: string = "Course Bundle Name";
    public static readonly GCID_RELATED_BUNDLE_ID: string = "Course Bundle ID";
    public static readonly IS_FOR_CURATION: string = "Is For Curation";
    public static readonly CREATED_BY_CORP: string = "Created By Corp";
    public static readonly CLIENT_OWNED_BUNDLE_NAME: string = "Client Bundle Name";
    public static readonly CLIENT_OWNED_BUNDLE_ID: string = "Client Bundle ID";

}